import React from "react"

type iTabProps = {
  activeTab: string
  controlName: string
  label: string
  onClick: () => void
  ref?: Record<string, unknown>
  tabId?: string
}

import * as s from "./Tab.module.scss"

const Tab = ({ activeTab, label, onClick, tabId, controlName }: iTabProps) => {
  const activeTabClass =
    activeTab === tabId
      ? `${s.Tab__listItem___active}`
      : `${s.Tab__listItem___inActive}`

  return (
    <button
      type="button" 
      role="tab" 
      aria-selected={activeTab === tabId ? 'true' : 'false'} 
      aria-controls={`${controlName}-tabpanel-${tabId}`}
      onClick={onClick}
      key={tabId}
      className={`${s.Tab__listItem} ${activeTabClass}`}
    >
      <span>{label}</span>
    </button>
  )
}

export default Tab
